import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from "./ModalContentWrapper";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import './ModalUploadDocument.scss' ;
import { Controller, useForm } from "react-hook-form";
import DropdownDocumentTypes from "root/ReactHookForm/ui/DropdownDocumentTypes";
import SingleFilePicker from "root/ReactHookForm/ui/SingleFilePicker";
import { deleteProviderDocument, saveProviderDocument } from "root/DataFunctions/DocumentFns";
import { UploadDocumentMode } from "root/Modals/useModalUploadDocument";

const ModalUploadDocument = ( props ) =>
{
    const [ generating, setGenerating ] = useState ( false );

    const { register, control, handleSubmit, setFocus, watch, formState: { errors: formErrors } } = useForm (
        {
            defaultValues: {
                document_title: '',
                document_type: 0,
                document: null
            }
        } );

    const primaryButtonStyle = {
        marginRight: '0px',
        marginLeft: '10px'

    };

    useEffect ( () =>
    {
        setFocus ( "document_title" );
    }, [ setFocus ] );

    const postDocument = ( data, onComplete ) =>
    {
        setGenerating ( true );

        saveProviderDocument ( props.params.provider_id, data, ( response ) =>
        {
            setGenerating ( false );

            props.onSaveCompleted ( response );
        } )
    }

    const onClickGenerate = () =>
    {
        handleSubmit ( onSubmit ) ();
    }

    const onClickDelete = ( onComplete ) =>
    {
        setGenerating ( true );

        deleteProviderDocument ( props.params.provider_id, props.params.enc_doc_id, ( response ) =>
        {
            setGenerating ( false );

            props.onSaveCompleted ( response );
        } )
    }

    const onClickCancel = () =>
    {
        props.onClose ();
    }

    const ErrorDiv = ( props ) =>
    {
        const style = { marginTop: '5px', color: 'red' };

        return <div style={ style }>{ props.children }</div>
    }

    const onSubmit = ( data ) =>
    {
        console.log ( data );

        postDocument ( data );
    }

    const validateDropdown = ( val ) =>
    {
        if ( val == 0 )
        {
            return "You must select a document type";
        }
    }

    const validatePicker = ( val ) =>
    {
        if ( val.length === 0 )
        {
            return "You must select a file";
        }
    }

    const formContentDelete = () =>
    {
        if ( generating )
        {
            return (
                <div style={ { textAlign: 'center', color: 'var(--vschool-mild-blue)', marginTop: '10px' } }>
                    <h4>Deleting document...</h4>
                    <h5 style={ { color: 'var(--vschool-mild-red)' } }>Please Wait - Do Not Refresh Your Screen</h5>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
        {
            return (
                <Fragment>
                    <div className='buy-card-right'>
                        <p>You are about to permanently delete this document.</p>
                        <p>Are you sure you wish to do this?</p>

                        <div className='modal-button-row'>
                            <button type="button" onClick={ onClickCancel } className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/></button>
                            <button type="button" onClick={ onClickDelete } style={ primaryButtonStyle } className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Delete Document<i className="et-check"/></button></div>
                    </div>
                </Fragment>
            )
        }
    }


    const formContentUpload = () =>
    {
        if ( generating )
        {
            return (
                <div style={ { textAlign: 'center', color: 'var(--vschool-mild-blue)', marginTop: '10px' } }>
                    <h4>Uploading document...</h4>
                    <h5 style={ { color: 'var(--vschool-mild-red)' } }>Please Wait - Do Not Refresh Your Screen</h5>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
        {
            return (
                <Fragment>
                    <div className='buy-card-right'>
                        <p>Complete the fields below to upload a document for this provider.</p>

                        <form className='registration-form' onSubmit={ handleSubmit ( onSubmit ) }>
                            <label>Document Title</label>
                            <input style={ { height: '100%' } } className='form-control'
                                   id='document_title' { ...register ( "document_title", { required: true } ) } />
                            { formErrors.document_title && <ErrorDiv>Please enter a document title</ErrorDiv> }

                            <label>Document Type</label>
                            <DropdownDocumentTypes readOnly={ false } control={ control } name='document_type'
                                                   rules={ { required: true } }
                                                   placeholder='Please select a document type'
                                                   isSearchable={ true }/>
                            { formErrors.document_type && <ErrorDiv>{ formErrors.document_type.message }</ErrorDiv> }

                            <label>Select a Document</label>
                            <Controller
                                control={ control }
                                name="document"
                                defaultValue={ [] }
                                rules={ { required: true, validate: validatePicker } }
                                render={ ( {
                                               field: { onChange, value, name, ref },
                                               fieldState: { invalid, isTouched, isDirty, error },
                                               formState,
                                           } ) => (
                                    <SingleFilePicker name='document' onChange={ onChange } value={ value }
                                                      inputRef={ ref }/>
                                ) }
                            />
                            { formErrors.document && <ErrorDiv>You Must Pick a File</ErrorDiv> }

                            <div className='modal-button-row'>
                                <button type="button" onClick={ onClickCancel }
                                        className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i
                                    className="et-arrow-bold-left"/></button>
                                <button type="button" onClick={ onClickGenerate } style={ primaryButtonStyle }
                                        className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Upload Now<i
                                    className="et-check"/></button>
                            </div>
                        </form>
                    </div>
                </Fragment>
            )
        }
    }

    const formTitle = ( formMode ) =>
    {
        switch ( formMode )
        {
            case UploadDocumentMode.UPLOAD:
                return 'Upload document';
            case UploadDocumentMode.DELETE:
                return 'Delete document';
            default:
                return '';
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <h3>{ formTitle ( props.mode ) }</h3>
            <div className='buy-card'>
                <div>
                <span className='glyphicon glyphicon-file'
                      style={ { color: 'var(--vschool-mild-blue)', fontSize: '15rem', marginTop: '30px' } }></span>
                </div>
                { ( props.mode === UploadDocumentMode.UPLOAD ) && formContentUpload () }
                { ( props.mode === UploadDocumentMode.DELETE ) && formContentDelete () }
            </div>
        </ModalContentWrapper>
    )
}

export default ModalUploadDocument;

ModalUploadDocument.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};
